import { type TreeNode } from '@direct-frontend/components';

// Этот костыль заставляет дерево чекбоксов работать как дерево радиокнопок,
// то есть одновременно может быть выбрано только одно значение.
// Важно, что все дочерние чекбоксы нужно показывать выделенными.
export function simulateSingleSelectValue(
    nodeMap: Map<string, TreeNode>,
    prevs: [string, boolean][],
    values: [string, boolean][]
): [string, boolean][] {
    const unselected = values.filter((value) => value.at(1) === false);

    if (unselected.length > 0) {
        return unselected.map((item) => [item[0], true]);
    }

    const selected = values.filter((value) => value.at(1) === true);

    if (selected.length > 1) {
        return selected.filter((item) => prevs.every((prev) => prev[0] !== item[0] || prev[1] === false));
    }

    const onlyOneSelected = selected[0];

    if (selected.length === 1 && prevs.some((prev) => prev[0] === onlyOneSelected[0] && prev[1] === true)) {
        const tree = nodeMap.get(onlyOneSelected[0]);

        if (tree?.children) {
            const el = tree.children.find((node) => values.every((val) => val[0] !== node.id));

            if (el) {
                return [[el?.id, true]];
            }
        }
    }

    return selected;
}
